import {
  GET_WEEKLY_EMAIL_SETTINGS,
  GET_WEEKLY_EMAIL_SETTINGS_SUCCESS,
  GET_WEEKLY_EMAIL_SETTINGS_FAILURE,
  UPDATE_WEEKLY_EMAIL_SETTINGS,
  UPDATE_WEEKLY_EMAIL_SETTINGS_SUCCESS,
  UPDATE_WEEKLY_EMAIL_SETTINGS_FAILURE,

  GET_NOTIFICATION_SETTINGS,
  GET_NOTIFICATION_SETTINGS_SUCCESS,
  GET_NOTIFICATION_SETTINGS_FAILURE,
  UPDATE_NOTIFICATION_SETTINGS,
  UPDATE_NOTIFICATION_SETTINGS_SUCCESS,
  UPDATE_NOTIFICATION_SETTINGS_FAILURE,
} from "../../modules/constants";
import { createNotification } from "../../modules/notificationManager";

// ------------------------------------
// Weekly Email Handlers
// ------------------------------------
export const getWeeklyEmailSettingsHandler = (state) => ({
  ...state,
  isLoading: true,
});
export const getWeeklyEmailSettingsSuccessHandler = (state, action) => {
  const { payload: { data } } = action;
  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      weeklyEmail: data.data.receive_weekly_email,
    };
  }
  return { ...state, isLoading: false };
};
export const getWeeklyEmailSettingsFailureHandler = (state) => ({
  ...state,
  isLoading: false,
  weeklyEmail: false,
});

export const updateWeeklyEmailSettingsHandler = (state) => ({
  ...state,
  isLoading: true,
});
export const updateWeeklyEmailSettingsSuccessHandler = (state, action) => {
  const { payload: { data } } = action;
  if (data.status === 200) {
    createNotification("success", "Weekly email settings updated successfully.");
    return {
      ...state,
      isLoading: false,
      weeklyEmail: data.data.receive_weekly_email,
    };
  }
  return { ...state, isLoading: false };
};
export const updateWeeklyEmailSettingsFailureHandler = (state) => {
  createNotification("error", "Weekly email update failed. Please try again.");
  return { ...state, isLoading: false };
};

// ------------------------------------
// Notification Handlers
// ------------------------------------
export const getNotificationSettingsHandler = (state) => ({
  ...state,
  isLoading: true,
});
export const getNotificationSettingsSuccessHandler = (state, action) => {
  const { payload: { data } } = action;
  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      notification: data.data.notification_on,
    };
  }
  return { ...state, isLoading: false };
};
export const getNotificationSettingsFailureHandler = (state) => ({
  ...state,
  isLoading: false,
  notification: false,
});

export const updateNotificationSettingsHandler = (state) => ({
  ...state,
  isLoading: true,
});
export const updateNotificationSettingsSuccessHandler = (state, action) => {
  const { payload: { data } } = action;
  if (data.status === 200) {
    createNotification("success", "Notification settings updated successfully.");
    return {
      ...state,
      isLoading: false,
      notification: data.data.notification_on,
    };
  }
  return { ...state, isLoading: false };
};
export const updateNotificationSettingsFailureHandler = (state) => {
  createNotification("error", "Notification update failed. Please try again.");
  return { ...state, isLoading: false };
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_WEEKLY_EMAIL_SETTINGS]: getWeeklyEmailSettingsHandler,
  [GET_WEEKLY_EMAIL_SETTINGS_SUCCESS]: getWeeklyEmailSettingsSuccessHandler,
  [GET_WEEKLY_EMAIL_SETTINGS_FAILURE]: getWeeklyEmailSettingsFailureHandler,
  [UPDATE_WEEKLY_EMAIL_SETTINGS]: updateWeeklyEmailSettingsHandler,
  [UPDATE_WEEKLY_EMAIL_SETTINGS_SUCCESS]: updateWeeklyEmailSettingsSuccessHandler,
  [UPDATE_WEEKLY_EMAIL_SETTINGS_FAILURE]: updateWeeklyEmailSettingsFailureHandler,

  [GET_NOTIFICATION_SETTINGS]: getNotificationSettingsHandler,
  [GET_NOTIFICATION_SETTINGS_SUCCESS]: getNotificationSettingsSuccessHandler,
  [GET_NOTIFICATION_SETTINGS_FAILURE]: getNotificationSettingsFailureHandler,
  [UPDATE_NOTIFICATION_SETTINGS]: updateNotificationSettingsHandler,
  [UPDATE_NOTIFICATION_SETTINGS_SUCCESS]: updateNotificationSettingsSuccessHandler,
  [UPDATE_NOTIFICATION_SETTINGS_FAILURE]: updateNotificationSettingsFailureHandler,
};

// ------------------------------------
// Initial state
// ------------------------------------
const initialState = {
  isLoading: false,
  weeklyEmail: false,
  notification: false,
};

export default function settingsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
